import { publicClient, privateClient } from "../../configs/axiosConfig";

const staffEndpoints = {
  getAllUserSide: "v2/staff/:operatorId/user-side",
  getStaffInfo: "v2/staff/:id",
};

const staffApi = {
  getAllStaffInfo: async (operatorId) => {
    try {
      const url = staffEndpoints.getAllUserSide.replace(
        ":operatorId",
        operatorId
      );

      const response = await privateClient.get(url);

      return { response };
    } catch (err) {
      return { err };
    }
  },
  getStaffInfo: async (id) => {
    try {
      const url = staffEndpoints.getStaffInfo.replace(":id", id);

      console.log({ url });
      const response = await privateClient.get(url);

      return { response };
    } catch (err) {
      return { err };
    }
  },
};

export default staffApi;
